import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import logo from "../../assets/IconMetuaa.png";
import "./HomePage.css";
import { Avatar } from "@mui/material";
import { apiUrl } from "../../Constants";
import BookingApi from "Services/Booking";
import loginApi from "../../Services/Login";
import { setAuthentication } from "../../Redux/Authentication/actions";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";

const headerLinks = [
  { label: "Covoiturage", href: "/" },
  { label: "Bus", href: "/" },
  { label: "Train", href: "/" },
  { label: "Livraison", href: "/" },
  { label: "Courses", href: "/" },
  { label: "Offres", href: "/", badge: "Nouveau" },
];

const footerColumns = [
  {
    title: "Entreprise",
    links: ["Ã€ propos", "CarriÃ¨res", "Presse", "Blog"],
  },
  {
    title: "Services",
    links: ["Covoiturage", "Bus", "Train", "Livraison", "Courses urbaines"],
  },
  {
    title: "Support",
    links: ["Centre d'aide", "Contact", "Conditions d'utilisation", "Politique de confidentialitÃ©"],
  },
];

const summaryTabs = [
  { label: "Tous", count: 72, active: true, mode: "all", subtitle: "Meilleures options" },
  { label: "Covoiturage", count: 45, active: false, mode: "car" },
  { label: "Bus", count: 21, active: false, mode: "bus" },
  { label: "Train", count: 6, active: false, mode: "train" },
];

const sortOptions = [
  { label: "DÃ©part le plus tÃ´t", checked: true, icon: "clock" },
  { label: "Prix le plus bas", icon: "price" },
  { label: "DurÃ©e du trajet", icon: "clock" },
  { label: "Meilleures Ã©valuations", icon: "star" },
  { label: "Trajets recommandÃ©s", icon: "thumb" },
];

const departureSlots = [
  { label: "00h00 - 06h00", count: 12 },
  { label: "06h00 - 12h00", count: 28 },
  { label: "12h00 - 18h00", count: 34, checked: true },
  { label: "18h00 - 23h59", count: 18 },
];

const comfortOptions = [
  { label: "Climatisation", count: 67 },
  { label: "Wi-Fi", count: 54 },
  { label: "Prises USB", count: 49 },
];

const onboardOptions = [
  { label: "Toilettes", count: 41 },
  { label: "Collation offerte", count: 36 },
];

const vehicleOptions = [{ label: "Berline", count: 24 }];

const resultCards = [
  {
    time: "14:30",
    duration: "3h00",
    arrival: "17:30",
    from: "YaoundÃ©",
    fromSub: "Mvan",
    to: "Douala",
    toSub: "Gare RoutiÃ¨re BonabÃ©ri",
    mode: "Covoiturage",
    company: "Jean M.",
    avatar: "JM",
    rating: "4.8",
    seats: "4 places disponibles",
    price: "3 500",
    currency: "FCFA",
    tag: "Meilleur prix",
    tagTone: "success",
    extras: ["Car", "Seat", "WiFi"],
  },
  {
    time: "15:00",
    duration: "3h30",
    arrival: "18:30",
    from: "YaoundÃ©",
    fromSub: "Mvan",
    to: "Douala",
    toSub: "Gare RoutiÃ¨re BonabÃ©ri",
    mode: "Bus",
    company: "Express Voyages",
    avatar: "EV",
    rating: "",
    seats: "Toilettes Ã  bord",
    price: "5 000",
    currency: "FCFA",
    tag: "TrÃ¨s demandÃ©",
    tagTone: "warning",
    extras: ["Bus", "Toilet", "Air"],
  },
  {
    time: "16:00",
    duration: "3h15",
    arrival: "19:15",
    from: "YaoundÃ©",
    fromSub: "Mvan",
    to: "Douala",
    toSub: "Gare RoutiÃ¨re BonabÃ©ri",
    mode: "Covoiturage",
    company: "Fabrice K.",
    avatar: "FK",
    rating: "4.9",
    seats: "3 places disponibles",
    price: "4 000",
    currency: "FCFA",
    tag: "",
    tagTone: "neutral",
    extras: ["Car", "Seat"],
  },
  {
    time: "17:00",
    duration: "3h20",
    arrival: "20:20",
    from: "YaoundÃ©",
    fromSub: "Mvan",
    to: "Douala",
    toSub: "Gare RoutiÃ¨re BonabÃ©ri",
    mode: "Train",
    company: "Camrail",
    avatar: "CR",
    rating: "",
    seats: "Wi-Fi",
    price: "7 500",
    currency: "FCFA",
    tag: "",
    tagTone: "neutral",
    extras: ["Train", "WiFi", "Air"],
  },
  {
    time: "18:00",
    duration: "3h40",
    arrival: "21:40",
    from: "YaoundÃ©",
    fromSub: "Mvan",
    to: "Douala",
    toSub: "Gare RoutiÃ¨re BonabÃ©ri",
    mode: "Bus",
    company: "General Express",
    avatar: "GE",
    rating: "",
    seats: "ClimatisÃ©",
    price: "5 500",
    currency: "FCFA",
    tag: "TrÃ¨s demandÃ©",
    tagTone: "warning",
    extras: ["Bus", "Toilet", "Air"],
  },
];

const DEFAULT_SEARCH_PARAMS = {
  from: "YaoundÃ©",
  to: "Douala",
  date: formatDateForApi(new Date()),
  passengers: 1,
};

function formatDateForApi(date) {
  if (!date) return "";
  if (typeof date === "string") return date.slice(0, 10);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function formatDateLabel(date) {
  if (!date) return "Samedi 30 mai";
  const [year, month, day] = String(date).split("-").map(Number);
  if (!year || !month || !day) return "Samedi 30 mai";
  return new Date(year, month - 1, day).toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long" });
}

function normalizeSearchResult(result) {
  const departure = new Date(result?.departure_at);
  const arrival = new Date(result?.estimated_arrival_at);
  const durationMinutes = Number.isNaN(departure.getTime()) || Number.isNaN(arrival.getTime())
    ? null
    : Math.max(0, Math.round((arrival.getTime() - departure.getTime()) / 60000));

  const formatTime = (date) => (Number.isNaN(date.getTime())
    ? "--"
    : date.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit", hour12: false }));

  const price = Number(result?.price_per_seat ?? 0);
  const driverName = [result?.driver?.first_name, result?.driver?.last_name].filter(Boolean).join(" ").trim();

  return {
    id: result?.id || `${result?.type}-${result?.departure_at}-${result?.price_per_seat}`,
    time: formatTime(departure),
    duration: durationMinutes ? `${Math.round(durationMinutes / 60)}h${String(durationMinutes % 60).padStart(2, "0")}` : "--",
    arrival: formatTime(arrival),
    from: result?.origin?.addressName || result?.origin?.name || "DÃ©part",
    fromSub: result?.origin?.name || result?.origin?.addressName || "",
    to: result?.destination?.addressName || result?.destination?.name || "Destination",
    toSub: result?.destination?.name || result?.destination?.addressName || "",
    mode: result?.type === "train" ? "Train" : result?.type === "bus" ? "Bus" : "Covoiturage",
    company: driverName || "Conducteur",
    avatar: driverName ? driverName.split(" ").map((part) => part[0]).join("").slice(0, 2).toUpperCase() : "TR",
    rating: "",
    seats: `${result?.available_seats ?? 0} places disponibles`,
    price: price.toLocaleString("fr-FR"),
    currency: result?.currency || "FCFA",
    tag: result?.type === "carpool" ? "Disponible" : "",
    tagTone: result?.type === "carpool" ? "success" : "neutral",
    extras: [
      result?.type === "train" ? "Train" : result?.type === "bus" ? "Bus" : "Car",
      "Seat",
    ],
    raw: result,
  };
}

function formatDurationFromRide(ride, fallback = "3h20") {
  if (!ride?.departure_at || !ride?.estimated_arrival_at) return fallback;
  const departure = new Date(ride.departure_at);
  const arrival = new Date(ride.estimated_arrival_at);
  if (Number.isNaN(departure.getTime()) || Number.isNaN(arrival.getTime())) return fallback;
  const durationMinutes = Math.max(0, Math.round((arrival.getTime() - departure.getTime()) / 60000));
  const hours = Math.floor(durationMinutes / 60);
  const minutes = String(durationMinutes % 60).padStart(2, "0");
  return `${hours}h${minutes}`;
}

function getStopCount(ride) {
  const explicitStops = ride?.stops_count ?? ride?.stop_count ?? ride?.number_of_stops ?? ride?.stops?.length;
  const stops = Number(explicitStops);
  if (Number.isFinite(stops) && stops >= 0) return stops;
  return 0;
}

function getTotalPrice(ride, passengers) {
  const seatPrice = Number(ride?.price_per_seat ?? ride?.raw?.price_per_seat ?? 0);
  const count = Number(passengers || 1);
  return seatPrice * Math.max(1, count);
}

function formatPrice(amount, fallback = "3 500") {
  const value = Number(amount);
  if (!Number.isFinite(value) || value <= 0) return fallback;
  return value.toLocaleString("fr-FR");
}

function SearchIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="11" cy="11" r="7.5" />
      <path d="m16.5 16.5 4.5 4.5" />
    </svg>
  );
}

function UserIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="7.5" r="3.5" />
      <path d="M4.5 20a7.5 7.5 0 0 1 15 0" />
    </svg>
  );
}

function MenuChevronIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m9 6 6 6-6 6" />
    </svg>
  );
}

function FooterFacebookIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M13.4 20v-7h2.4l.4-2.7h-2.8V8.6c0-.8.2-1.5 1.3-1.5h1.6V4.7c-.3 0-1.1-.1-2.1-.1-2.1 0-3.5 1.2-3.5 3.6v2.1H8.4V13h2.3v7h2.7Z" />
    </svg>
  );
}

function FooterXIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6 5h3.1l3.7 5 4-5H19l-5.2 6.5L19.4 19h-3.1l-4.1-5.5L7.8 19H5.6l5.5-6.9L6 5Z" />
    </svg>
  );
}

function FooterYoutubeIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M21 12c0 2.6-.3 4.2-.7 5-.2.5-.6.9-1.1 1.1-.9.4-3.5.7-7.2.7s-6.3-.3-7.2-.7c-.5-.2-.9-.6-1.1-1.1-.4-.8-.7-2.4-.7-5s.3-4.2.7-5c.2-.5.6-.9 1.1-1.1.9-.4 3.5-.7 7.2-.7s6.3.3 7.2.7c.5.2.9.6 1.1 1.1.4.8.7 2.4.7 5Z" />
      <path fill="#fff" d="m10 8.8 5 3.2-5 3.2V8.8Z" />
    </svg>
  );
}

function FooterInstagramIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="5" y="5" width="14" height="14" rx="4" />
      <circle cx="12" cy="12" r="3.3" />
      <circle cx="16.6" cy="7.6" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

function FooterTiktokIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M14.2 4.5c.5 1.6 1.7 2.8 3.3 3.2v2.4a6.3 6.3 0 0 1-3.1-.8v5.1a4.8 4.8 0 1 1-4.8-4.8c.3 0 .7 0 1 .1v2.5a2.5 2.5 0 1 0 1.5 2.2V4.5h2.1Z" />
    </svg>
  );
}

function LocationIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 21s6-5.3 6-11a6 6 0 0 0-12 0c0 5.7 6 11 6 11Z" />
      <circle cx="12" cy="10" r="2.25" fill="none" />
    </svg>
  );
}

function SwapIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m6 8 3-3 3 3" />
      <path d="M9 5v14" />
      <path d="m18 16-3 3-3-3" />
      <path d="M15 19V5" />
    </svg>
  );
}

function CalendarIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="4.5" width="18" height="16" rx="2.5" />
      <path d="M8 2.8v4M16 2.8v4M3 9h18" />
    </svg>
  );
}

function PassengerIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="7.5" r="3.5" />
      <path d="M4.5 20a7.5 7.5 0 0 1 15 0" />
    </svg>
  );
}

function ChevronDownIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m6 9 6 6 6-6" />
    </svg>
  );
}

function ChevronLeftIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m14 6-6 6 6 6" />
    </svg>
  );
}

function ChevronRightIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m10 6 6 6-6 6" />
    </svg>
  );
}

function ArrowIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
      <path d="M5 12h14M12 5l7 7-7 7" />
    </svg>
  );
}

function CarIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M5 13.5 6.6 9.2A2.4 2.4 0 0 1 8.9 7.5h6.2a2.4 2.4 0 0 1 2.3 1.7L19 13.5" />
      <rect x="4" y="13.5" width="16" height="4.5" rx="1.5" />
      <circle cx="8" cy="18.5" r="1.2" />
      <circle cx="16" cy="18.5" r="1.2" />
    </svg>
  );
}

function BusIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <rect x="5" y="4.5" width="14" height="14" rx="3" />
      <path d="M8 8h8M8 11.5h8M8 15h5" />
      <circle cx="8" cy="18.5" r="0.9" fill="currentColor" stroke="none" />
      <circle cx="16" cy="18.5" r="0.9" fill="currentColor" stroke="none" />
    </svg>
  );
}

function TrainIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <rect x="6" y="4.5" width="12" height="14.5" rx="3" />
      <path d="M8.5 8h7M8.5 11.5h7M8.5 15h7" />
      <path d="M9 19 7.8 20.5M15 19 16.2 20.5" />
      <circle cx="10" cy="18.5" r="0.75" fill="currentColor" stroke="none" />
      <circle cx="14" cy="18.5" r="0.75" fill="currentColor" stroke="none" />
    </svg>
  );
}

function SearchFieldIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <circle cx="12" cy="12" r="7.5" />
      <path d="m17.5 17.5 3.5 3.5" />
    </svg>
  );
}

function SearchButtonIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true">
      <circle cx="11" cy="11" r="7.5" />
      <path d="m16.5 16.5 4.5 4.5" />
    </svg>
  );
}

function ClockIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5v5l3 2" />
    </svg>
  );
}

function StarIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path d="m12 4 2.6 5.2 5.8.8-4.2 4.1 1 5.8L12 17.7 6.8 20l1-5.8L3.6 10l5.8-.8L12 4Z" />
    </svg>
  );
}

function ThumbIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path d="M9.5 20h8a2 2 0 0 0 2-1.7l1-6A2 2 0 0 0 18.5 10H14l.7-3.5A2 2 0 0 0 12.8 4c-.8 0-1.6.5-1.9 1.3L8.5 10H5v10h4.5Z" />
    </svg>
  );
}

function WifiIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path d="M5 9a11 11 0 0 1 14 0" />
      <path d="M8.5 12a6 6 0 0 1 7 0" />
      <path d="M12 15.5h0" />
    </svg>
  );
}

function ToiletIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path d="M8 4.5h8v3H8z" />
      <path d="M9 7.5v5a3 3 0 0 0 6 0v-5" />
      <path d="M7.5 13h9l-.8 6h-7.4l-.8-6Z" />
    </svg>
  );
}

function SeatIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path d="M8 5v8a2 2 0 0 0 2 2h7" />
      <path d="M7 15h10l-1 4H8l-1-4Z" />
    </svg>
  );
}

function AirIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path d="M4 12h16" />
      <path d="M8 8.5V15" />
      <path d="M12 7v10" />
      <path d="M16 8.5V15" />
    </svg>
  );
}

function MapIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path d="M8 5.5 3.5 7.5v11l4.5-2 4.5 2 4.5-2 4.5 2v-11L17 5.5l-4.5 2-4.5-2Z" />
      <path d="M8 5.5v11M13 7.5v11M17 5.5v11" />
    </svg>
  );
}

function RadioIcon({ checked }) {
  return <span className={`ride-radio ${checked ? "is-checked" : ""}`} aria-hidden="true" />;
}

function CheckboxIcon({ checked }) {
  return <span className={`ride-checkbox ${checked ? "is-checked" : ""}`} aria-hidden="true" />;
}

function ModeIcon({ mode }) {
  if (mode === "Bus") return <BusIcon />;
  if (mode === "Train") return <TrainIcon />;
  return <CarIcon />;
}

function AmenityIcon({ kind }) {
  if (kind === "Bus") return <BusIcon />;
  if (kind === "Train") return <TrainIcon />;
  if (kind === "Toilet") return <ToiletIcon />;
  if (kind === "WiFi") return <WifiIcon />;
  if (kind === "Air") return <AirIcon />;
  if (kind === "Seat") return <SeatIcon />;
  return <CarIcon />;
}

function ShieldCheckIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" aria-hidden="true">
      <path d="M12 3.5 19 6.4v5.2c0 4.4-3 7.8-7 9.4-4-1.6-7-5-7-9.4V6.4L12 3.5Z" />
      <path d="m8.5 12.1 2.4 2.4 4.8-5" />
    </svg>
  );
}

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!isMenuOpen) return undefined;

    const handleOutsideClick = (event) => {
      if (!menuRef.current?.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") setIsMenuOpen(false);
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isMenuOpen]);

  return (
    <header className="bbc-nav-shell">
      <div className="bbc-container bbc-nav-container">
        <div className="bbc-nav">
          <Link to="/" className="bbc-logo" aria-label="METUA'A">
            <img src={logo} alt="Logo METUA'A" className="bbc-logo-image" />
            <span>METUA&apos;A</span>
          </Link>

          <nav className="bbc-main-links" aria-label="Navigation principale">
            {headerLinks.map((item) => (
              <a key={item.label} href={item.href} className="bbc-main-link">
                <span>{item.label}</span>
                {item.badge ? <span className="bbc-main-badge">{item.badge}</span> : null}
              </a>
            ))}
          </nav>

          <div className="bbc-right">
            <button type="button" className="bbc-icon-btn" aria-label="Rechercher">
              <SearchIcon />
            </button>
            <a href="/" className="bbc-propose">
              Proposer un trajet
            </a>
            <span className="bbc-flag" aria-label="France">
              <i />
              <i />
              <i />
            </span>
            <button
              type="button"
              className="bbc-avatar-btn"
              aria-label="Ouvrir le menu utilisateur"
              aria-expanded={isMenuOpen}
              onClick={() => setIsMenuOpen((current) => !current)}
            >
              <span className="bbc-avatar" aria-hidden="true">
                <UserIcon />
              </span>
            </button>
          </div>

          {isMenuOpen ? (
            <div className="bbc-user-menu" ref={menuRef}>
              <Link to="/" className="bbc-user-menu-item" onClick={() => setIsMenuOpen(false)}>
                <span>Connexion</span>
                <MenuChevronIcon />
              </Link>
              <Link to="/" className="bbc-user-menu-item" onClick={() => setIsMenuOpen(false)}>
                <span>Inscription</span>
                <MenuChevronIcon />
              </Link>
            </div>
          ) : null}
        </div>
      </div>
    </header>
  );
}

function Footer() {
  return (
    <footer className="bbc-footer">
      <div className="bbc-container bbc-footer-inner">
        <div className="bbc-footer-top">
          <div className="bbc-footer-branding">
            <Link to="/" className="bbc-footer-logo" aria-label="METUA'A">
              <img src={logo} alt="Logo METUA'A" className="bbc-footer-logo-image" />
              <span>METUA&apos;A</span>
            </Link>
            <p>
              Metua'a est la super application de mobilitÃ© au Cameroun.
              Covoiturage, Bus, Train, Livraison et bien plus encore.
            </p>
            <div className="bbc-social" aria-label="Reseaux sociaux">
              <a href="/" aria-label="Facebook"><FooterFacebookIcon /></a>
              <a href="/" aria-label="X"><FooterXIcon /></a>
              <a href="/" aria-label="YouTube"><FooterYoutubeIcon /></a>
              <a href="/" aria-label="Instagram"><FooterInstagramIcon /></a>
              <a href="/" aria-label="TikTok"><FooterTiktokIcon /></a>
            </div>
          </div>

          <div className="bbc-footer-grid">
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h4>{column.title}</h4>
                <ul>
                  {column.links.map((link) => (
                    <li key={link}>
                      <a href="/">{link}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="bbc-footer-newsletter">
            <h4>Newsletter</h4>
            <p>Recevez nos offres et nouveautÃ©s</p>
            <form className="bbc-newsletter-form">
              <input type="email" placeholder="Votre email" aria-label="Votre email" />
              <button type="button">S'abonner</button>
            </form>
          </div>
        </div>

        <div className="bbc-footer-bottom">
          <div>Â© 2024 Metua'. Tous droits rÃ©servÃ©s.</div>
          <div className="bbc-footer-made">
            <span>Made with</span>
            <span className="bbc-heart" aria-hidden="true">â™¥</span>
            <span>in Cameroun</span>
            <span className="bbc-cameroon-flag" aria-hidden="true">
              <i />
              <i />
              <i />
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}

function SearchBar() {
  return (
    <section className="ride-search-shell">
      <div className="ride-search-card">
        <div className="ride-search-grid">
          <div className="ride-search-field">
            <span className="ride-search-icon"><LocationIcon /></span>
            <div>
              <strong>YaoundÃ©, Cameroun</strong>
            </div>
          </div>

          <div className="ride-search-swap">
            <span className="ride-swap-bubble" aria-hidden="true">
              <SwapIcon />
            </span>
          </div>

          <div className="ride-search-field">
            <span className="ride-search-icon"><LocationIcon /></span>
            <div>
              <strong>Douala, Cameroun</strong>
            </div>
          </div>

          <div className="ride-search-field">
            <span className="ride-search-icon"><CalendarIcon /></span>
            <div>
              <strong>Aujourd'hui, 24 mai</strong>
            </div>
          </div>

          <div className="ride-search-field ride-search-passenger">
            <span className="ride-search-icon"><UserIcon /></span>
            <div>
              <strong>1 passager</strong>
            </div>
            <ChevronDownIcon />
          </div>

          <button type="button" className="ride-search-button">
            <span>Rechercher</span>
            <SearchButtonIcon />
          </button>
        </div>
      </div>
    </section>
  );
}

function EditableSearchBar({ searchParams, setSearchParams, onSearch, searchLoading }) {
  const currentDate = searchParams?.date || DEFAULT_SEARCH_PARAMS.date;

  return (
    <section className="ride-search-shell">
      <div className="ride-search-card">
        <div className="ride-search-grid">
          <label className="ride-search-field">
            <span className="ride-search-icon"><LocationIcon /></span>
            <input
              type="text"
              value={searchParams.from || ""}
              onChange={(event) => setSearchParams((current) => ({ ...current, from: event.target.value }))}
              placeholder="DÃ©part"
              aria-label="DÃ©part"
            />
          </label>

          <div className="ride-search-swap">
            <span className="ride-swap-bubble" aria-hidden="true">
              <SwapIcon />
            </span>
          </div>

          <label className="ride-search-field">
            <span className="ride-search-icon"><LocationIcon /></span>
            <input
              type="text"
              value={searchParams.to || ""}
              onChange={(event) => setSearchParams((current) => ({ ...current, to: event.target.value }))}
              placeholder="ArrivÃ©e"
              aria-label="ArrivÃ©e"
            />
          </label>

          <label className="ride-search-field">
            <span className="ride-search-icon"><CalendarIcon /></span>
            <input
              type="date"
              value={currentDate}
              onChange={(event) => setSearchParams((current) => ({ ...current, date: event.target.value }))}
              aria-label="Date"
            />
          </label>

          <label className="ride-search-field ride-search-passenger">
            <span className="ride-search-icon"><UserIcon /></span>
            <input
              type="number"
              min="1"
              max="8"
              value={searchParams.passengers || 1}
              onChange={(event) => setSearchParams((current) => ({ ...current, passengers: Math.max(1, Number(event.target.value) || 1) }))}
              aria-label="Nombre de passagers"
            />
            <ChevronDownIcon />
          </label>

          <button type="button" className="ride-search-button" onClick={onSearch} disabled={searchLoading}>
            <span>{searchLoading ? "Recherche..." : "Rechercher"}</span>
            <SearchButtonIcon />
          </button>
        </div>
      </div>
    </section>
  );
}

function getAuthPayload(responseData) {
  return responseData?.data || responseData || {};
}

function getAuthToken(authData) {
  return authData?.accessToken || authData?.token || authData?.tokens?.accessToken || authData?.auth?.accessToken;
}

function persistAuthSession(authData) {
  const token = getAuthToken(authData);
  if (!token) return null;

  const user = authData?.user || {};
  const lewooPayToken = authData?.lewooPay?.token || authData?.lewooPayToken || "";
  const lewooPaySession = authData?.lewooPay?.session || authData?.lewooPaySession || null;
  localStorage.setItem("isAuthenticated", true);
  localStorage.setItem("token", token);
  localStorage.setItem("tokenExpiration", Date.now() + 24 * 60 * 60 * 1000);
  localStorage.setItem("userid", user?.id || authData?.id || "");
  localStorage.setItem("userType", user?.userType || authData?.userType || "");
  if (lewooPayToken) {
    localStorage.setItem("lewooPayToken", lewooPayToken);
  } else {
    localStorage.removeItem("lewooPayToken");
  }
  if (lewooPaySession) {
    localStorage.setItem("lewooPaySession", JSON.stringify(lewooPaySession));
  } else {
    localStorage.removeItem("lewooPaySession");
  }

  if (authData?.sub_companyName) {
    localStorage.setItem("subcompany", authData.sub_companyName);
  } else {
    localStorage.removeItem("subcompany");
  }

  return token;
}

function ReservationLoginModal({ open, onClose, form, setForm, onSubmit, loading, error }) {
  if (!open) return null;

  return (
    <div className="ride-auth-overlay" role="presentation" onClick={onClose}>
      <div className="ride-auth-modal" role="dialog" aria-modal="true" aria-labelledby="ride-auth-title" onClick={(event) => event.stopPropagation()}>
        <div className="ride-auth-accent" />
        <button type="button" className="ride-auth-close" onClick={onClose} aria-label="Fermer">×</button>
        <div className="ride-auth-header">
          <span className="ride-auth-badge">Connexion requise</span>
          <h2 id="ride-auth-title">Connectez-vous pour réserver</h2>
          <p>La réservation garde l'ambiance Metua'a: simple, propre et rassurante.</p>
        </div>

        <form className="ride-auth-form" onSubmit={onSubmit}>
          <label className="ride-auth-field">
            <span>Email</span>
            <input
              type="email"
              value={form.email}
              onChange={(event) => setForm((current) => ({ ...current, email: event.target.value }))}
              placeholder="exemple@email.com"
              autoComplete="email"
            />
          </label>

          <label className="ride-auth-field">
            <span>Mot de passe</span>
            <input
              type="password"
              value={form.password}
              onChange={(event) => setForm((current) => ({ ...current, password: event.target.value }))}
              placeholder="••••••••"
              autoComplete="current-password"
            />
          </label>

          {error ? <div className="ride-auth-error">{error}</div> : null}

          <div className="ride-auth-actions">
            <button type="button" className="ride-auth-secondary" onClick={onClose}>Annuler</button>
            <button type="submit" className="ride-auth-primary" disabled={loading}>{loading ? "Connexion..." : "Se connecter et réserver"}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

function SidebarFilterGroup({ title, action, children }) {
  return (
    <section className="ride-filter-group">
      <div className="ride-filter-head">
        <h3>{title}</h3>
        {action ? <button type="button">{action}</button> : null}
      </div>
      {children}
    </section>
  );
}

function FilterRow({ label, count, checked = false, icon }) {
  return (
    <label className={`ride-filter-row ${checked ? "is-checked" : ""}`}>
      <span className="ride-filter-row-left">
        {icon === "radio" ? <RadioIcon checked={checked} /> : <CheckboxIcon checked={checked} />}
        <span>{label}</span>
      </span>
      <span className="ride-filter-count">{count}</span>
    </label>
  );
}

function Sidebar() {
  return (
    <aside className="ride-sidebar">
      <div className="ride-map-card">
        <div className="ride-map-visual" aria-hidden="true">
          <div className="ride-map-road ride-map-road-a" />
          <div className="ride-map-road ride-map-road-b" />
          <div className="ride-map-road ride-map-road-c" />
          <div className="ride-map-marker" />
          <div className="ride-map-marker ride-map-marker-2" />
        </div>
        <a href="/" className="ride-map-button">
          <MapIcon />
          <span>Afficher sur la carte</span>
        </a>
      </div>

      <div className="ride-filters">
        <SidebarFilterGroup title="Trier par" action="Tout effacer">
          <div className="ride-filter-list">
            {sortOptions.map((option) => (
              <div className={`ride-filter-row ${option.checked ? "is-checked" : ""}`} key={option.label}>
                <span className="ride-filter-row-left">
                  <RadioIcon checked={option.checked} />
                  <span>{option.label}</span>
                </span>
                <span className="ride-filter-count ride-filter-icon">
                  {option.icon === "clock" ? <ClockIcon /> : null}
                  {option.icon === "price" ? <span className="ride-mini-dot" /> : null}
                  {option.icon === "star" ? <StarIcon /> : null}
                  {option.icon === "thumb" ? <ThumbIcon /> : null}
                </span>
              </div>
            ))}
          </div>
        </SidebarFilterGroup>

        <SidebarFilterGroup title="Heure de dÃ©part">
          <div className="ride-filter-list">
            {departureSlots.map((option) => (
              <FilterRow key={option.label} {...option} icon="checkbox" />
            ))}
          </div>
        </SidebarFilterGroup>

        <SidebarFilterGroup title="Confort">
          <div className="ride-filter-list">
            {comfortOptions.map((option) => (
              <FilterRow key={option.label} {...option} icon="checkbox" />
            ))}
          </div>
        </SidebarFilterGroup>

        <SidebarFilterGroup title="Prix">
          <div className="ride-range">
            <div className="ride-range-track">
              <span className="ride-range-fill" />
              <span className="ride-range-handle ride-range-handle-left" />
              <span className="ride-range-handle ride-range-handle-right" />
            </div>
            <div className="ride-range-labels">
              <span>2 000 FCFA</span>
              <span>25 000 FCFA</span>
            </div>
          </div>
        </SidebarFilterGroup>

        <SidebarFilterGroup title="Services Ã  bord">
          <div className="ride-filter-list">
            {onboardOptions.map((option) => (
              <FilterRow key={option.label} {...option} icon="checkbox" />
            ))}
          </div>
        </SidebarFilterGroup>

        <SidebarFilterGroup title="Type de vÃ©hicule">
          <div className="ride-filter-list">
            {vehicleOptions.map((option) => (
              <FilterRow key={option.label} {...option} icon="checkbox" />
            ))}
          </div>
        </SidebarFilterGroup>
      </div>
    </aside>
  );
}

function ResultTag({ tag, tone }) {
  if (!tag) return null;
  return <span className={`ride-price-tag is-${tone}`}>{tag}</span>;
}

function ResultAmenity({ kind, label }) {
  return (
    <span className="ride-amenity">
      <AmenityIcon kind={kind} />
      <span>{label}</span>
    </span>
  );
}

function ResultCard({ item }) {
  return (
    <article className="ride-card">
      <div className="ride-card-main">
        <div className="ride-timeline">
          <div className="ride-time-block">
            <strong>{item.time}</strong>
            <span>{item.from}</span>
            <small>{item.fromSub}</small>
          </div>

          <div className="ride-time-line">
            <span className="ride-time-duration">{item.duration}</span>
            <span className="ride-time-track">
              <i />
            </span>
          </div>

          <div className="ride-time-block is-arrival">
            <strong>{item.arrival}</strong>
            <span>{item.to}</span>
            <small>{item.toSub}</small>
          </div>
        </div>

        <div className="ride-meta-row">
          <span className="ride-mode">
            <ModeIcon mode={item.mode} />
            <span>{item.mode}</span>
          </span>
          <span className="ride-company">
            <span className="ride-avatar">{item.avatar}</span>
            <span>{item.company}</span>
          </span>
          {item.rating ? (
            <span className="ride-rating">
              <StarIcon />
              <span>{item.rating}</span>
            </span>
          ) : null}
          <span className="ride-seats">
            <SeatIcon />
            <span>{item.seats}</span>
          </span>
          <div className="ride-extra-list">
            {item.extras.includes("WiFi") ? <ResultAmenity kind="WiFi" label="Wiâ€‘Fi" /> : null}
            {item.extras.includes("Toilet") ? <ResultAmenity kind="Toilet" label="Toilettes Ã  bord" /> : null}
            {item.extras.includes("Air") ? <ResultAmenity kind="Air" label="ClimatisÃ©" /> : null}
          </div>
        </div>
      </div>

      <div className="ride-card-side">
        <div className="ride-price">
          <strong>{item.price}</strong>
          <span>{item.currency}</span>
        </div>
        <ResultTag tag={item.tag} tone={item.tagTone} />
        <button type="button" className="ride-details-btn">
          Voir les dÃ©tails
        </button>
      </div>
    </article>
  );
}

function MainResults() {
  return (
    <section className="ride-main">
      <div className="ride-tabs">
        {summaryTabs.map((tab) => (
          <div key={tab.label} className={`ride-tab ${tab.active ? "is-active" : ""}`}>
            <div className="ride-tab-top">
              <span className="ride-tab-icon">
                {tab.mode === "car" ? <CarIcon /> : null}
                {tab.mode === "bus" ? <BusIcon /> : null}
                {tab.mode === "train" ? <TrainIcon /> : null}
                {tab.mode === "all" ? <CarIcon /> : null}
              </span>
              <span>{tab.label}</span>
              <strong>{tab.count}</strong>
            </div>
            {tab.subtitle ? <small>{tab.subtitle}</small> : null}
          </div>
        ))}
      </div>

      <div className="ride-list-head">
        <h2>Aujourd'hui, 24 mai</h2>
        <strong>72 trajets disponibles</strong>
      </div>

      <div className="ride-cards">
        {resultCards.map((item) => (
          <ResultCard key={`${item.time}-${item.mode}-${item.price}`} item={item} />
        ))}
      </div>

      <div className="ride-load-more">
        <button type="button">Charger plus de rÃ©sultats</button>
      </div>
    </section>
  );
}

export default function HomeRideDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state?.AuthReducer?.isAuthenticated || false);
  const selectedRide = location.state?.selectedRide || null;
  const [searchParams, setSearchParams] = useState(() => location.state?.searchParams || DEFAULT_SEARCH_PARAMS);
  const [searchLoading, setSearchLoading] = useState(false);
  const [reserveLoading, setReserveLoading] = useState(false);
  const [reserveModalOpen, setReserveModalOpen] = useState(false);
  const [authForm, setAuthForm] = useState({ email: "", password: "" });
  const [authError, setAuthError] = useState("");

  const tripDuration = formatDurationFromRide(selectedRide);
  const stopCount = getStopCount(selectedRide);
  const availableSeats = Number(selectedRide?.available_seats ?? selectedRide?.raw?.available_seats ?? 0);
  const totalPrice = getTotalPrice(selectedRide, searchParams.passengers);
  const displayDate = searchParams?.date ? formatDateLabel(searchParams.date) : 'Samedi 30 mai';
  const journeyTitle = selectedRide
    ? `${selectedRide?.origin?.addressName || selectedRide?.origin?.name || 'Départ'} → ${selectedRide?.destination?.addressName || selectedRide?.destination?.name || 'Arrivée'}`
    : 'Détails du trajet';

  const buildBookingPayload = () => {
    const passengerCount = Math.max(1, Number(searchParams.passengers || 1));
    const seatPrice = Number(selectedRide?.price_per_seat ?? selectedRide?.raw?.price_per_seat ?? 0);
    const serviceFee = Number(selectedRide?.service_fee ?? selectedRide?.raw?.service_fee ?? 0);
    return {
      ride_id: selectedRide?.raw?.ride_id || selectedRide?.raw?.id || selectedRide?.ride_id || selectedRide?.id || '',
      pickup_waypoint_id: selectedRide?.raw?.pickup_waypoint_id || selectedRide?.pickup_waypoint_id || '',
      dropoff_waypoint_id: selectedRide?.raw?.dropoff_waypoint_id || selectedRide?.dropoff_waypoint_id || '',
      seats_booked: passengerCount,
      total_amount: seatPrice * passengerCount,
      service_fee: serviceFee,
      currency: selectedRide?.currency || selectedRide?.raw?.currency || 'XAF',
    };
  };

  const reserveRide = async () => {
    const payload = buildBookingPayload();
    if (!payload.ride_id) {
      dispatch(showSnackbar({
        message: 'Impossible de réserver ce trajet pour le moment.',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
        variant: 'error',
      }));
      return;
    }

    dispatch(showLoader('Loading please wait...'));
    setReserveLoading(true);
    try {
      const response = await BookingApi.createBooking(payload);
      dispatch(hideLoader());
      dispatch(showSnackbar({
        message: response?.data?.message || 'Réservation effectuée avec succès',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
        variant: 'success',
      }));
      navigate('/dashboard-client', {
        state: {
          booking: response?.data?.data || response?.data || null,
        },
      });
    } catch (error) {
      dispatch(hideLoader());
      dispatch(showSnackbar({
        message: error?.response?.data?.message || 'Erreur lors de la réservation',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
        variant: 'error',
      }));
    } finally {
      setReserveLoading(false);
    }
  };

  const handleReserveNow = () => {
    if (!isAuthenticated) {
      setAuthError('');
      setReserveModalOpen(true);
      return;
    }
    reserveRide();
  };

  const handleAuthSubmit = async (event) => {
    event.preventDefault();
    setAuthError('');
    setReserveLoading(true);
    try {
      const res = await loginApi.login({ email: authForm.email, password: authForm.password });
      const authData = getAuthPayload(res?.data);
      const token = persistAuthSession(authData);
      if (!token) {
        throw new Error('Connexion impossible');
      }
      dispatch(setAuthentication(authData));
      setReserveModalOpen(false);
      await reserveRide();
    } catch (error) {
      const message = error?.response?.data?.message || error?.message || 'Email ou mot de passe incorrect';
      setAuthError(message);
      dispatch(showSnackbar({
        message,
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
        variant: 'error',
      }));
    } finally {
      setReserveLoading(false);
    }
  };

  const runSearch = async () => {
    const from = (searchParams.from || '').trim();
    const to = (searchParams.to || '').trim();
    if (!from || !to) return;

    setSearchLoading(true);
    try {
      const response = await axios.get(`${apiUrl}/api/v1/search`, {
        params: {
          from,
          to,
          date: formatDateForApi(searchParams.date || DEFAULT_SEARCH_PARAMS.date),
          passengers: Number(searchParams.passengers || 1),
          modes: 'carpool,train',
          max_price: 5000,
          sort_by: 'departure_at',
          page: 0,
          limit: 20,
        },
      });

      navigate('/home-ride', {
        state: {
          searchParams,
          searchResults: (response?.data?.results || []).map(normalizeSearchResult),
        },
      });
    } catch (error) {
      navigate('/home-ride', {
        state: {
          searchParams,
          searchResults: [],
        },
      });
    } finally {
      setSearchLoading(false);
    }
  };

  return (
    <div className="bbc-page ride-page">
      <Header />
      <main className="ride-main-shell">
        <div className="bbc-container ride-page-inner">
          <EditableSearchBar
            searchParams={searchParams}
            setSearchParams={setSearchParams}
            onSearch={runSearch}
            searchLoading={searchLoading}
          />
          <section className="ride-details-main">
            <h1 className="ride-details-title">{journeyTitle}</h1>

            <div className="ride-details-grid">
              <div className="ride-details-left">
                <article className="ride-itinerary-card">
                  <div className="ride-summary-timeline">
                    <div className="ride-summary-row">
                      <div className="ride-summary-time">
                        <strong>
                          {selectedRide?.departure_at
                            ? new Date(selectedRide.departure_at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
                            : '17:00'}
                        </strong>
                        <span>{tripDuration}</span>
                      </div>
                      <div className="ride-summary-track" aria-hidden="true">
                        <span className="ride-summary-dot" />
                        <span className="ride-summary-line" />
                        <span className="ride-summary-dot is-end" />
                      </div>
                      <div className="ride-summary-stop">
                        <strong>{selectedRide?.origin?.addressName || selectedRide?.origin?.name || 'Point de départ'}</strong>
                        <span>{selectedRide?.origin?.name || selectedRide?.origin?.addressName || 'Départ'}</span>
                      </div>
                    </div>

                    <div className="ride-summary-stop-label">
                      <ClockIcon />
                      <span>{tripDuration} · {stopCount} arrêt{stopCount > 1 ? 's' : ''}</span>
                    </div>

                    <div className="ride-summary-row is-arrival">
                      <div className="ride-summary-time">
                        <strong>
                          {selectedRide?.estimated_arrival_at
                            ? new Date(selectedRide.estimated_arrival_at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
                            : '20:20'}
                        </strong>
                      </div>
                      <div className="ride-summary-track" aria-hidden="true">
                        <span className="ride-summary-dot" />
                        <span className="ride-summary-line" />
                        <span className="ride-summary-dot is-end" />
                      </div>
                      <div className="ride-summary-stop">
                        <strong>{selectedRide?.destination?.addressName || selectedRide?.destination?.name || "Point d'arrivée"}</strong>
                        <span>{selectedRide?.destination?.name || selectedRide?.destination?.addressName || 'Arrivée'}</span>
                      </div>
                    </div>
                  </div>
                </article>

                <article className="ride-detail-card">
                  <div className="ride-detail-icon is-soft">
                    <ShieldCheckIcon />
                  </div>
                  <div className="ride-detail-copy">
                    <h3>Annulations et échanges</h3>
                    <p>Échangeable et remboursable sous forme de bon d'achat, sans frais jusqu'à 30 jours avant le départ.</p>
                  </div>
                  <span className="ride-detail-chevron" aria-hidden="true">
                    <ChevronRightIcon />
                  </span>
                </article>

                <article className="ride-detail-card is-accent">
                  <div className="ride-detail-icon">
                    <BusIcon />
                  </div>
                  <div className="ride-detail-copy">
                    <h3>{selectedRide?.driver?.first_name } {selectedRide?.driver?.last_name }</h3>
                    {/* <p>Transport professionnel</p> */}
                    <p>Transport </p>
                    <div className="ride-amenities">
                      <span className="ride-amenity">
                        <AirIcon />
                        <span>Climatisé</span>
                      </span>
                      <span className="ride-amenity">
                        <WifiIcon />
                        <span>Wi-Fi à bord</span>
                      </span>
                      <span className="ride-amenity">
                        <SeatIcon />
                        <span>Prises USB</span>
                      </span>
                      <span className="ride-amenity">
                        <ShieldCheckIcon />
                        <span>Voyage sécurisé</span>
                      </span>
                    </div>
                  </div>
                </article>

                <article className="ride-driver-card">
                  <div className="ride-driver-avatar" aria-hidden="true">
                    <Avatar
                      src="../../assets/images/user/avatar.png"
                      alt="Avatar"
                      sx={{
                        width: '100%',
                        height: '100%',
                        bgcolor: '#16a34a',
                        fontSize: 14,
                        fontWeight: 700,
                      }}
                    />
                  </div>
                  <div className="ride-driver-copy">
                    <h3>{selectedRide?.driver?.first_name } {selectedRide?.driver?.last_name }</h3>
                    <p>Conducteur </p>
                    {/* <p>Conducteur vérifié</p> */}
                    <div className="ride-driver-meta">
                      <span className="ride-driver-rating">
                        <StarIcon />
                        <span>4.8</span>
                      </span>
                      <span className="ride-driver-reviews">124 avis</span>
                    </div>
                  </div>
                </article>
              </div>

              <aside className="ride-summary-panel">
                <div className="ride-summary-card">
                  <h3>{displayDate}</h3>

                  <div className="ride-summary-timeline">
                    <div className="ride-summary-row">
                      <div className="ride-summary-time">
                        <strong>
                          {selectedRide?.departure_at
                            ? new Date(selectedRide.departure_at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
                            : '17:00'}
                        </strong>
                        <span>{tripDuration}</span>
                      </div>
                      <div className="ride-summary-track" aria-hidden="true">
                        <span className="ride-summary-dot" />
                        <span className="ride-summary-line" />
                        <span className="ride-summary-dot is-end" />
                      </div>
                      <div className="ride-summary-stop">
                        <strong>{selectedRide?.origin?.addressName || selectedRide?.origin?.name || 'Point de départ'}</strong>
                        <span>{selectedRide?.origin?.name || selectedRide?.origin?.addressName || 'Départ'}</span>
                      </div>
                    </div>

                    <div className="ride-summary-stop-label">
                      <ClockIcon />
                      <span>{tripDuration} · {stopCount} arrêt{stopCount > 1 ? 's' : ''}</span>
                    </div>

                    <div className="ride-summary-row is-arrival">
                      <div className="ride-summary-time">
                        <strong>
                          {selectedRide?.estimated_arrival_at
                            ? new Date(selectedRide.estimated_arrival_at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
                            : '20:20'}
                        </strong>
                      </div>
                      <div className="ride-summary-track" aria-hidden="true">
                        <span className="ride-summary-dot" />
                        <span className="ride-summary-line" />
                        <span className="ride-summary-dot is-end" />
                      </div>
                      <div className="ride-summary-stop">
                        <strong>{selectedRide?.destination?.addressName || selectedRide?.destination?.name || "Point d'arrivée"}</strong>
                        <span>{selectedRide?.destination?.name || selectedRide?.destination?.addressName || 'Arrivée'}</span>
                      </div>
                    </div>
                  </div>

                  <div className="ride-summary-type">
                    <CarIcon />
                    <span>Covoiturage</span>
                  </div>
                </div>

                <div className="ride-booking-card">
                  <div className="ride-availability">
                    <ClockIcon />
                    <span>{availableSeats} place{availableSeats > 1 ? 's' : ''} disponible{availableSeats > 1 ? 's' : ''}</span>
                  </div>

                  <div className="ride-price-row">
                    <div className="ride-passenger-count">
                      {searchParams.passengers || 1} passager{Number(searchParams.passengers || 1) > 1 ? 's' : ''}
                    </div>
                    <div className="ride-price-block">
                      <strong>{formatPrice(totalPrice)}</strong>
                      <span>FCFA</span>
                    </div>
                  </div>

                  <button type="button" className="ride-book-now-btn" onClick={handleReserveNow} disabled={reserveLoading}>
                    {reserveLoading ? "Patientez..." : "Réserver maintenant"}
                  </button>
                </div>
              </aside>
            </div>
          </section>
        </div>
      </main>
      <ReservationLoginModal
        open={reserveModalOpen}
        onClose={() => setReserveModalOpen(false)}
        form={authForm}
        setForm={setAuthForm}
        onSubmit={handleAuthSubmit}
        loading={reserveLoading}
        error={authError}
      />
      <Footer />
    </div>
  );
}




